<template>
    <Popup :open="open" @open="this.$emit('update:open', (open = !open))" :padding="true">
        <Loading :loading="loading" preserveHeight="true">
            <div v-if="showConfirmCancel">
                <p>{{ $t('are_you_sure_cancel_abonnement') }}:</p>
                <strong class="my-2 block">
                    {{ $translate(abonnement.product.name) }}
                </strong>

                <div class="flex flex-col gap-4 mt-4">
                    <FormButton type="submit" class="w-auto" styling="primary xs flex items-center gap-3 text-xs" @click="showConfirmCancel = false" :value="$t('plain_abort')">
                    </FormButton>
                    <FormButton
                        type="submit"
                        class="w-auto"
                        styling="secondary xs flex items-center gap-3 text-xs"
                        @click="processCancelAbonnement(abonnement)"
                        :value="$t('terminate_abonnement')"
                    >
                    </FormButton>
                </div>
            </div>
            <div v-else>
                <div class="py-4 border-b border-gray-300 w-full">
                    <strong>
                        {{ $t('plain_abonnements') }}
                    </strong>
                </div>
                <div v-if="getByKey('cancel')?.data?.length" class="overflow-y-auto overflow-x-clip flex flex-col gap-4 mt-4">
                    <div v-if="regionCheck(getByKey('cancel').data) === 0" class="my-4">
                        <p class="text-center mb-4">
                            {{
                                $t('you_dont_have_any_subscriptions_are_you_looking_for_your_subscriptions', {
                                    count: 0,
                                    dont_have_language: getRegion() === 'de' ? $t('lang_german_plural') : $t('lang_english_plural'),
                                    looking_for_language: getRegion() === 'de' ? $t('lang_english_plural') : $t('lang_german_plural')
                                })
                            }}
                        </p>
                        <button @click="redirect(getRegion() === 'de' ? 'en' : 'de')" class="btn primary flex items-center gap-3 w-22 m-auto justify-center">
                            {{
                                $t('switch_to_url', {
                                    url: getRegion() === 'de' ? $t('lang_english') : $t('lang_german')
                                })
                            }}
                        </button>
                    </div>
                    <ListAbonnement v-for="abonnement in getByKey('cancel').data" :key="abonnement.id" :abonnement="abonnement" @cancel="cancelAbonnement($event)" />
                </div>
                <div v-else class="my-4">
                    {{ $t('no_data') }}
                </div>
            </div>

            <Pagination :limit="3" :data="getByKey('cancel')" @pagination-change-page="paginate" />
        </Loading>
    </Popup>
</template>

<script>
import { mapGetters } from 'vuex';
import i18next from 'i18next';
import _ from 'lodash';
import { getRegion } from '../../helpers.js';

export default {
    mounted() {
        this.loading = true;
        this.indexAbonnements().then((response) => {
            this.loading = false;
        });
    },

    methods: {
        getRegion,
        paginate(page = 1) {
            this.indexAbonnements({
                page: page
            });
        },
        async indexAbonnements(params) {
            let config = {
                params: {
                    'sort[by]': 'created_at',
                    per_page: 100,
                    key: 'cancel',
                    current: true,
                    terminated: false
                }
            };

            _.merge(config.params, params);

            return await this.$store.dispatch('abonnements/index', config);
        },
        cancelAbonnement(abonnement) {
            this.showConfirmCancel = true;
            this.abonnement = abonnement;
        },
        processCancelAbonnement(abonnement) {
            this.loading = true;
            this.$store
                .dispatch('abonnements/cancel', abonnement.id)
                .then(() => {
                    this.loading = false;
                    this.$emit('update:open', false);
                    this.$toast.success(i18next.t('msg_abonnement_canceled'));

                    // reload the abonnements in parent component
                    this.$parent.indexAbonnements();
                })
                .catch(() => {
                    this.loading = false;
                    this.$toast.error(i18next.t('msg_abonnement_canceled_error'));
                });
        },
        regionCheck(abos) {
            return abos.filter((abo) => abo.region === (window?.meta?.region_configuration.region === 'ch' ? 'ch' : 'de')).length;
        },
        redirect(targetRegion) {
            if (window.location.href.includes('test')) {
                this.environment = 'local';
            } else if (window.location.href.includes('staging')) {
                this.environment = 'staging';
            } else if (window.location.href.includes('dev')) {
                this.environment = 'dev';
            } else {
                this.environment = 'prod';
            }

            window.location.href = `https://${this.urls[targetRegion][this.environment]}`;
        }
    },

    data: () => ({
        loading: false,
        showConfirmCancel: false,
        abonnement: null,
        urls: {
            de: {
                local: 'www.hkcm.test',
                staging: 'staging.hkcmanagement.de',
                dev: 'dev.hkcmanagement.de',
                prod: 'www.hkcmanagement.de'
            },
            en: {
                local: 'www.hkcmglobal.test',
                staging: 'staging.hkcmglobal.com',
                dev: 'dev.hkcmglobal.com',
                prod: 'www.hkcmglobal.com'
            }
        }
    }),

    props: ['open'],
    emits: ['update:open'],

    watch: {
        open: function () {
            this.$emit('update:open', this.open);
        }
    },

    computed: {
        ...mapGetters('abonnements', ['getByKey'])
    }
};
</script>
